/** @jsxRuntime classic */
/** @jsx jsx */
import { Link, Text } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import { ListRow, ListRowBody } from '../List';
import ProducerHeader from '../Producer/ProducerHeader';
import DistributionContacts from './BrandContacts/DistributionContacts';
import BrandLogo from './BrandLogo';
import useLink from '../../useLink';
import { Trans } from '@lingui/macro';

export default function PresentedBrand({ brand, ...rest }) {
  const getLink = useLink();
  return (
    <ListRow {...rest} sx={{ boxShadow: '' }}>
      {brand.profile.logo && (
        <BrandLogo
          brand={brand.profile}
          sx={{ margin: 3, marginRight: 0, position: 'relative' }}
        />
      )}
      <ListRowBody sx={{ position: 'relative', padding: undefined }}>
        <ProducerHeader producer={brand} />
        {/* There are 2 types of distribution contacts, and both may be displayed simultaneously */}
        {/* These are the contacts that are typically collected for an in-country event */}
        <DistributionContacts brand={brand} />
        {/* These are the distributors on the brand profile */}
        {brand.profile.distributors?.totalCount > 0 && (
          <Text>
            {/* Scroll to distribution section */}
            <Link
              to={`${getLink.producer({
                producerId: brand.brandId,
              })}#distributors`}
            >
              <Trans>See global distribution</Trans>
            </Link>
          </Text>
        )}
      </ListRowBody>
    </ListRow>
  );
}

export const fragment = graphql`
  fragment PresentedBrand on Bottlebooks_RegisteredBrand {
    name
    nameWithoutPrefixAndSuffix: name # TODO Fix
    ...bb_RegisteredBrand_BrandLogoDefault
    ...bb_DistributionContacts
    ...useLink_bb_RegisteredBrand
    profile {
      distributors {
        totalCount
      }
    }
  }
`;
